export const types = [
  {
    type: '常见问题',
    questions: [2, 3, 0, 36, 37, 38, 39, 40, 41, 42, 43],
  },
  {
    type: '注册与登录',
    questions: [0, 1, 2, 3, 4],
  },
  {
    type: '邮件收发',
    questions: [6, 7, 8, 10, 11, 12, 13, 14, 15, 16, 17]
  },
  {
    type: '邮箱设置',
    questions: [18, 19, 20, 21, 22, 23]
  },
  {
    type: '存储空间',
    questions: [24]
  },
  {
    type: '文件夹',
    questions: [25, 26]
  },
  {
    type: '星标邮件',
    questions: [27]
  },
  {
    type: '通讯录',
    questions: [28, 44]
  },
  {
    type: '支付问题',
    questions: [29, 30, 31]
  },
  {
    type: '安全问题',
    questions: [32, 33]
  },
  {
    type: '客户端',
    questions: [34, 35]
  },
  
]

export const questions = [
  {
    index: 0,
    question: '怎样注册搜狐VIP邮箱？',
    answer: `
    <p>在登录页选择注册，进入注册页面，根据步骤导引，输入您想要注册的邮箱地址，设置密码并进行手机验证，点击提交即可完成账号注册。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_0_0.png" /></p>
    `
  }, {
    index: 1,
    question: '怎么更改绑定的手机号？',
    answer: `
    <p>到邮箱设置里，选择账号设置，点击更换手机号。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_1_0.png" /></p>
    `
  }, {
    index: 2,
    question: '忘记密码怎么办？',
    answer: `
    <p>1、如果您忘记密码，请点击登录页的忘记密码，通过邮箱绑定的的手机号找回。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_2_0.png" alt=""></p>
    <p>2、接下来进入到找回密码页面，按照指示依次输入您的邮箱名和验证码，点击下一步。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_2_1.png" alt=""></p>
    <p>3、然后根据绑定的手机号点击发送验证码，如果手机号无法使用，选择申诉找回，若收不到短信验证码，点击获取语音验证码，输入手机收到的短信验证码。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_2_2.png" alt=""></p>
    <p>4、点击下一步，输入新密码。</p>
    `
  }, {
    index: 3,
    question: '如何修改邮箱密码？',
    answer: `
    <p>1、到邮箱设置里，选择账号设置，点击修改密码。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_3_0.png" alt=""></p>
    <p>2、点击发送验证码，输入手机验证码后进入下一步。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_3_1.png" alt=""></p>
    <p>3、输入新密码和再次确认密码，点击提交即可。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_3_2.png" alt=""></p>
    `
  }, {
    index: 4,
    question: '登录时提示用户名不存在？',
    answer: `
    <p>登录邮箱提示“用户名不存在”？可能是以下原因：</p>
    <p>· 您输错用户名，该用户名还未注册过。</p>
    <p>· 您邮箱太长时间未使用过，已被系统删除。</p>
    `
  }, {
    index: 5,
    question: '',
    answer: ''
  }, {
    index: 6,
    question: '如何发送草稿箱里的邮件？',
    answer: `
    <p>1、进入“草稿箱”文件夹。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_6_0.png" alt=""></p>
    <p>2、打开您需要发送的邮件进行编辑，完成后点击“发送”即可。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_6_1.png" alt=""></p>
    `
  }, {
    index: 7,
    question: '怎么上传多个附件？',
    answer: `
    <p>您可以在添加附件时一次性选择多个文件，也可以在邮件编辑页面重复选择添加附件。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_7_0.png" alt=""></p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_7_1.png" alt=""></p>
    `
  }, {
    index: 8,
    question: '一封邮件最多可发给多少人？',
    answer: `
    <p>收件人数并不是统一的数量限制，而是受产品类型、用户状态和反垃圾策略的影响。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_8_0.png" alt=""></p>
    `
  }, {
    index: 9,
    question: '',
    answer: `
    <p>转到邮箱设置的。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_9_0.png" alt=""></p>
    `
  }, {
    index: 10,
    question: '可以与海外用户往来邮件吗？',
    answer: `
    <p>可以的 。</p>
    `
  }, {
    index: 11,
    question: '如何转发邮件？',
    answer: `
    <p>打开您要转发的邮件，在右上角点击指向右侧的箭头，即转发按钮，进入邮件编辑页面，在收件人一栏添加您要转发的地址，发送即可。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_11_0.png" alt=""></p>
    `
  }, {
    index: 12,
    question: '如何回复邮件？',
    answer: `
    <p>在读信页面下方可选择立即回复，也可以通过读信页面右上方的的回复/全部回复按钮进行邮件回复。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_12_0.png" alt=""></p>
    `
  }, {
    index: 13,
    question: '如何设置定时发送邮件？',
    answer: `
    <p>在写信页下方，点击更多选项，可以选择定时发送。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_13_0.png" alt=""></p>
    `
  }, {
    index: 14,
    question: '邮件收不到？',
    answer: `
    <p>如果您没有收到邮件，请检查电子邮箱是否有问题。可以采用以下方法测试：</p>
    <p>1、首先给自己发一封邮件，如果发信正常并且能够收到邮件，说明一切正常，没有问题；</p>
    <p>2、检查收信规则的过滤设置。在邮箱页面右上角点击“邮箱设置”，打开设置页面，点击“收信规则”，检查过滤规则的条件是否设置不当，如选择满足条件的邮件执行“直接删除”或“转发后删除”操作；</p>
    <p>3、检查反垃圾设置。在邮箱页面右上角打开“邮箱设置”，打开设置页面，查看“黑名单”，若发现黑名单中误加入了正常的邮箱地址，从黑名单中删除以后就可以收到对方的来信了；</p>
    <p>4、将对方的邮件地址加入白名单，设置方法是：点击“邮箱设置”标签，然后点击“白名单”，输入要加入白名单的邮箱地址，点击添加，该地址显示在列表框中，设置成功；</p>
    <p>如果以上测试都正常，则可能由线路、邮件服务器故障等原因造成邮件并没有发送到搜狐VIP邮箱的服务器， 可以和发件人联系一下，看看对方是否有收到退信信息，可以根据退信信息判断问题所在，或者与客服联系。</p>
    `
  }, {
    index: 15,
    question: '邮件不小心删除了怎么办？',
    answer: `
    <p>如果重要邮件不小心删除，可到已删除文件夹下查看邮件是否存在。如果不存在，可以联系客服找回一定时间内的邮件。</p>
    `
  }, {
    index: 16,
    question: '如果邮件中有乱码怎么办？',
    answer: `
    <p>点击页面右上角“常见反馈”，将您的问题发送给<a href="mailto:feedback@vip.sohu.com">feedback@vip.sohu.com。</a></p>
    `
  }, {
    index: 17,
    question: '如何使用需要回执？',
    answer: `
    <p>如果您勾选写信编辑框下方的“需要回执”，当收件人打开您的邮件时，就会提示收件人是否发送回执。如果对方发送了回执，您便可以通过自己邮箱中的邮件确认对方是否收到了该邮件，并可知道对方是什么时候阅读的该邮件。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_17_0.png" alt=""></p>
    `
  }, {
    index: 18,
    question: '什么是黑白名单，如何设置？',
    answer: `
    <p>加入“黑名单”中的地址或域的邮件，将会被拒收。加入到“白名单”中的地址或域的邮件，将不会被当做垃圾邮件过滤。且地址簿中的所有联系人，已默认加入白名单。</p>
    <p>添加黑名单的步骤：</p>
    <p>1、进入邮箱设置页面，选择“黑名单”；</p>
    <p>2、输入添加的黑名单地址，点击添加按钮，可以看到下方的黑名单列表出现了您添加的黑名单地址，上方显示“添加黑名单成功”。如需添加多个黑名单地址，继续输入地址，点击添加按钮即可。</p>
    <p style="font-weight: bold">白名单设置同上。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_18_0.png" alt=""></p>
    `
  }, {
    index: 19,
    question: '自动回复/转发',
    answer: `
    <p style="font-weight: bold;">设置自动转发：</p>
    <p>1、进入邮箱设置页面，选择“自动转发”；</p>
    <p>2、在添加转发地址处输入自动转发地址，点击添加按钮；</p>
    <p>3、添加后点击保存，根据提示输入验证码。保存成功后，转发邮箱显示为“待验证”状态，并且转发的邮箱会收到一封确认邮件，然后等待对方进行验证。</p>
    <p>4、自动转发邮箱验证后，验证状态变为“已验证”，默认开启转发状态。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_19_0.png" alt=""></p>
    <p style="font-weight: bold;">设置自动回复：</p>
    <p>搜狐邮箱自动回复默认为关闭状态，若开启自动回复，则按下述步骤：</p>
    <p>1、进入邮箱设置页面，选择“自动回复”；</p>
    <p>2、勾选“在以下时间内开启自动回复”，设置自动回复的时间周期，编辑自动回复文本或者直接使用默认文本，点击保存即可。 (注意：同一联系人每日只自动回复一次）</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_19_1.png" alt=""></p>
    `
  }, {
    index: 20,
    question: '如何代收其他邮箱的邮件？',
    answer: `
    <p>1、进入邮箱设置页面，选择“代收设置”；</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_9_0.png" alt=""></p>
    <p>2、在代收设置里，点击添加代收邮箱，出现如下界面：</p>
    <p>输入代收邮箱的地址和密码（如果需要授权登录的请使用对应的授权密码登录）。完成后点击确定。如果系统自动识别服务器，可以不作修改，如果未识别，可以手动输入服务器地址和端口。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_20_0.png" alt=""></p>
    `
  }, {
    index: 21,
    question: '如何设置每页显示邮件数？',
    answer: `
    <p>进入邮箱设置页面，选择“基础设置”，在读信设置下可调整每页显示的邮件数目。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_21_0.png" alt=""></p>
    `
  }, {
    index: 22,
    question: '如何更换邮箱皮肤？',
    answer: `
    <p>进入邮箱设置页面，选择“换肤”；只要点击相应的皮肤，即可刷新到选中的邮箱界面风格，下图为“木纹”皮肤的效果图。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_22_0.png" alt=""></p>
    `
  }, {
    index: 23,
    question: '如何设置收信规则？',
    answer: `
    <p>1、进入邮箱设置页面，选择“收信规则”，然后点击“添加收信规则。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_23_0.png" alt=""></p>
    <p>2、根据个人需要勾选“规则状态”，输入条件关键字。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_23_1.png" alt=""></p>
    <p>3、设置满足条件时的执行动作，比如移动，标记星标，设为已读等等。点击保存。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_23_2.png" alt=""></p>
    `
  // }, {
  //   index: 24,
  //   question: '云附件容量',
  //   answer: `
  //   <p>精英VIP套餐，10G超大云附件；</p>
  //   <p>尊享VIP套餐，20G超大云附件。</p>
  //   `
  }, {
    index: 24,
    question: '邮件空间容量',
    answer: `
    <p>精英VIP套餐，10G邮箱容量；</p>
    <p>尊享VIP套餐，20G邮箱容量。</p>
    `
  }, {
    index: 25,
    question: '如何管理文件夹？',
    answer: `
    <p>文件夹包含系统文件夹和自定义文件夹两部分，在系统文件夹下，您可以对已删除的邮件和垃圾邮件进行清空，也可以设置自动清理时间。在自定义文件夹下，您可以对新建文件夹进行 “重命名”、“删除”、“清空”、“设置自动清理时间”等操作。</p>
    <img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_26_0.png" alt="">
    `
  }, {
    index: 26,
    question: '如何使用文件夹？',
    answer: `
    <p>您可以把系统文件夹的邮件转移到自定义的文件夹加以保存。可以对系统文件夹下的邮件采用“删除”、“移至”到其他文件夹等方法进行管理。</p>
    `
  }, {
    index: 27,
    question: '什么是星标邮件？如何使用？',
    answer: `
    <p>星标邮件会被收藏在名为星标邮件文件夹下。具体可通过点击邮件列表或邮件详情中的星号，将邮件标记为星标邮件，也可选中该邮件，点击顶部操作栏中的“标记”进行标记和取消星标邮件。</p>
    <img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_28_0.png" alt="">
    `
  }, {
    index: 28,
    question: '如何新建联系人？',
    answer: `
    <p>登录邮箱后，点击上方的“通讯录”按钮，进入后选择“新建联系人”，选择分组，填入其基本信息，点击保存。</p>
    <img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_29_0.png" alt="">
    <img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_29_1.png" alt="">
    `
  }, {
    index: 29,
    question: '支付宝/微信支付',
    answer: `
    <p>若您选择支付宝支付，点击立即支付，则跳转到支付宝支付页面，打开手机支付宝客户端扫一扫完成支付。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_30_0.png" alt=""></p>
    <p>若您选择微信支付，则在下方会出现二维码，打开微信扫一扫，完成支付。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_30_1.png" alt=""></p>
    `
  }, {
    index: 30,
    question: '去哪里查询我的续费记录？',
    answer: `
    <p>1、将鼠标移至右上角头像或用户名处，会出现提示框，点击立即续费，进入到支付中心页面，选择续费记录，即可查看自己的续费记录。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_31_0.png" alt=""></p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_31_1.png" alt=""></p>
    `
  }, {
    index: 31,
    question: '如何申请电子发票？',
    answer: `
    <p>1、在消费记录中点击“开发票”。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_32_0.png" alt=""></p>
    <p>2、将弹窗中的信息填写好后点击“申请开票”即可。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_32_1.png" alt=""></p>
    `
  }, {
    index: 32,
    question: '我怎样处理垃圾邮件？',
    answer: `
    <p>如果您的收件箱收到垃圾邮件，可以按照下面步骤处理：</p>
    <p>1、在邮件列表中勾选需要拒绝的邮件。</p>
    <p>2、点击“举报”按钮，则会将该邮件移到垃圾邮件箱，如果将发件人地址加入黑名单，以后就不会收到此发件人发送的垃圾邮件。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_33_0.png" alt=""></p>
    `
  }, {
    index: 33,
    question: '用搜狐邮箱会导致我的电脑系统中毒吗？',
    answer: `
    <p>如果您只是在搜狐邮箱页面浏览、阅读邮件内容，不会导致系统中毒。</p>
    `
  }, {
    index: 34,
    question: '如何配置POP客户端？',
    answer: `
    <p style="font-weight: bold;">• Foxmail配置：</p>
    <p>1、在Foxmail安装完毕后，第一次运行，新建账户，选择手动设置（高级设置）。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_35_0-1.png" alt=""></p>
    <p>2、账号配置。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_35_1-1.png" alt=""></p>
    <p style="font-weight: bold;">• Outlook配置：</p>
    <p>1、添加账户后点击“下一步”。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_35_2-1.png" alt=""></p>
    <p>2、选择服务，勾选 “POP 或 IMAP(P)”。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_35_3-1.png" alt=""></p>
    <p>3、POP 或 IMAP(P)账户设置。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_35_4-1.png" alt=""></p>
    <p>4、点击“其他设置”，进入“发送服务器”并勾选“我的发送服务器（SMTP）要求验证（O）”。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_35_5-1.png" alt=""></p>
    `
  }, {
    index: 35,
    question: '如何配置IMAP客户端？',
    answer: `
    <p>IMAP，即Internet Message Access Protocol（互联网邮件访问协议），IMAP与POP类似，都是一种邮件获取协议。与POP不同的是，IMAP是"双向"的：</p>
    <p>1、在WEB邮箱上的文件夹可以同步到IMAP客户端；</p>
    <p>2、在邮件客户端上所作的删除、转移等操作，都可同步到WEB邮箱上；</p>
    <p style="font-weight: bold;">• Foxmail配置：</p>
    <p>1、在Foxmail安装完毕后，第一次运行，新建账户，选择手动设置（高级设置）。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_36_0-1.png" alt=""></p>
    <p>2、账号配置。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_36_1-1.png" alt=""></p>
    <p style="font-weight: bold;">• Outlook客户端IMAP配置：</p>
    <p>1、添加账户后点击“下一步”。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_36_2-1.png" alt=""></p>
    <p>2、选择服务，勾选 “POP 或 IMAP(P)”。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_36_3-1.png" alt=""></p>
    <p>3、POP 或 IMAP(P)账户设置。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_36_4-1.png" alt=""></p>
    <p>4、点击“其他设置”，进入“发送服务器”并勾选“我的发送服务器（SMTP）要求验证（O）”。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_36_5-1.png" alt=""></p>
    `
  }, {
    index: 36,
    question: '我的密码无效是什么原因？',
    answer: `
    <p>常见的原因有：</p>
    <p>· 您的键盘大写键（Caps Lock）被按下，导致需要小写输入的密码无效，或者大写键被放开，导致需要大写输入的密码无效；</p>
    <p>· 检查您的用户名是否输入正确；</p>
    <p>· 检查您的密码是否输入正确；</p>
    <p>· 您的VIP账号可能被盗用，一旦发生这种情况，可通过常见反馈将问题反馈给我们。</p>
    `
  }, {
    index: 37,
    question: '怎样发送邮件？',
    answer: `
    <p>1、登录搜狐VIP邮箱后，点击“写邮件”进行邮件撰写、编辑，然后按照下面步骤进行发送。</p>
    <p>2、在“收件人”一栏中填入收件人的邮件地址，如果需要填入多个地址，在地址之间用“;”隔开，或直接点击写信页面右边的联系人列表中一位或多位联系人，选中的联系人地址将会自动填写在“收件人”一栏中（例如：abc@vip.sohu.com）；</p>
    <p>3、若您想抄送信件，请点击“添加抄送”，将会出现抄送地址输入栏。抄送就是将信同时也发给收信人以外的人，请将他（她）的 email 地址写在这一栏中。如果是多个地址，在地址间请用“;”隔开，也可多次点击右边的联系人列表选择多个收件人，与此同时收件人知道您将这封信抄送给其他人；</p>
    <p>4、若您想密送信件，请点击“添加密送”，将会出现密送地址输入栏，再填写密送人的 email 地址。密送就是将信秘密发送给收件/抄送人以外的一方，比如，如果您将信发送给 abc@vip.sohu.com 并密送给 123@vip.sohu.com，则信的收件人 abc@vip.sohu.com 并不知道您同时也将信发送给了123@vip.sohu.com；</p>
    <p>5、“主题”一栏中填入邮件的主题；</p>
    <p>6、如果您需要随信附上文件或者图片，请点击“添加附件”，在弹出的对话框中，选择您要添加的附件后点“打开”即可；将鼠标置于附件上，会出现×按钮，点击×即可删除附件。若要添加多个附件，请重复点击“继续添加”；</p>
    <p>7、在正文框中填写您的信件正文；</p>
    <p>8、点击“发送”按钮，邮件就可以发送出去。如果粘贴了附件，在发送的同时，附件将同信件正文一起发送出去。</p>
    `
  }, {
    index: 38,
    question: '关于POP3、SMTP和IMAP',
    answer: `
    <p>1、POP3是Post Office Protocol 3的简称，即邮局协议的第3个版本，它规定怎样将个人计算机连接到Internet的邮件服务器和下载电子邮件的电子协议。它是因特网电子邮件的第一个离线协议标准，POP3允许用户从服务器上把邮件存储到本地主机（即自己的计算机）上，同时可保留邮件服务器上的邮件，而POP3服务器则是遵循 POP3协议的接收邮件服务器，用来接收电子邮件的。</p>
    <p>2、SMTP的全称是“Simple Mail Transfer Protocol”，即简单邮件传输协议。它是一组用于从源地址到目的地址传输邮件的规范，通过它来控制邮件的中转方式。SMTP协议属于TCP/IP协议簇，它帮助每台计算机在发送或中转信件时找到下一个目的地。SMTP服务器就是遵循SMTP协议的发送邮件服务器。（SMTP认证，简单地说就是要求必须在提供了账户名和密码之后才可以登录SMTP服务器，这就使得那些垃圾邮件的散播者无可乘之机。增加SMTP认证的目的是为了使用户避免受到垃圾邮件的侵扰。）</p>
    <p>3、IMAP全称是“Internet Mail Access Protocol”，即交互式邮件存取协议，它是跟POP3类似的邮件访问标准协议之一。不同的是，开启了IMAP后，您在电子邮件客户端收取的邮件仍然保留在服务器上，同时在客户端上的操作都会反馈到服务器上，如：删除邮件，标记已读等，服务器上的邮件也会做相应的动作。所以无论从浏览器登录邮箱或者客户端软件登录邮箱，看到的邮件以及状态都是一致的。</p>
    `
  }, {
    index: 39,
    question: '怎样确保邮箱的使用安全？',
    answer: `
    <p>1、登录搜狐VIP邮箱后，您可以使用完全退出登录的方式退出邮箱，点击“退出”即可，不要采用直接关闭浏览器的方式退出。</p>
    <p>2、避免在互联网上公开您的搜狐VIP邮箱地址。</p>
    <p>3、避免向不信任的人透露您的搜狐VIP邮箱地址，在公共场合上网时要避免被旁人窥视，保护好您的用户信息，在退出邮箱后消除历史记录。</p>
    `
  }, {
    index: 40,
    question: '怎样退出邮箱？',
    answer: `
    <p>鼠标置于右上方您的头像或用户名，会出现如下界面提示，点击退出登录即可。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_41_0.png" alt=""></p>
    `
  }, {
    index: 41,
    question: '邮箱空间达到存储限制了，还能收到邮件吗？',
    answer: `
    <p>不能，邮件将会被退回发件人，如果您不清理部分存储空间就无法再接收新的邮件。</p>
    `
  }, {
    index: 42,
    question: '为什么发信人被列入搜狐VIP邮箱反垃圾黑名单？',
    answer: `
    <p>由于您的发信账号/域/IP存在不良发信历史（包括但不限于发送垃圾邮件、违法邮件、被其他用户举报、被国际反垃圾组织投诉等），被列入搜狐邮箱黑名单，限制发信。如有异议，请致电客服。</p>
    `
  }, {
    index: 43,
    question: '邮件被当成垃圾邮件无法发送？',
    answer: `
    <p>发送正常邮件，却被当成垃圾邮件，无法成功发送。此现象主要是由于邮件标题或者内容命中了反垃圾的规则。搜狐邮箱不允许通过电子邮件发送违法违规、色情以及未经收件人请求而发送的商业广告、宣传、推广营销等邮件。建议发件人：</p>
    <p>1、优化邮件内容与主题重新发信；</p>
    <p>2、发件前核对清楚收件人地址是否存在；</p>
    <p>3、减少发送大量相同/相似内容，适当降低发件频率与数量。</p>
    <p>垃圾邮件定义：中国互联网协会反垃圾邮件规范规定，包括下述属性的电子邮件均属于垃圾邮件：</p>
    <p>· 收件人事先没有提出要求或者同意接收的广告、电子刊物、各种形式的宣传品等宣传性的电子邮件；</p>
    <p>· 收件人无法拒收的电子邮件；</p>
    <p>· 隐藏发件人身份、地址、标题等信息的电子邮件；</p>
    <p>· 含有虚假的信息源、发件人、路由等信息的电子邮件；</p>
    <p>· 主题行或内容包含错误、误导或虚假的信息；</p>
    <p>· 违反了国家相关法律规定的信息；</p>
    <p>· 容易引起用户反感、举报、投诉的信息。</p>
    `
  }, {
    index: 44,
    question: '如何新建联系人组？',
    answer: `
    <p>1、在邮箱上方目录栏选择通讯录，点击“联系人组”右侧的“+”。</p>
    <p>2、输入组名称。</p>
    <p>3、选中要添加至该组的联系人，最终保存。</p>
    <p><img src="//1cbbb2d148753.cdn.sohucs.com/d92698/img/help_45_0.png" alt=""></p>
    `
  }
]


// WEBPACK FOOTER //
// ./src/page/help/questions-json.js